import { AuditContactForm } from "@shared/forms/contact-form/audit-contact-form";
import { useLocale } from "@translations/locale-context";
import { TextLink } from "@ui/components/text-link/text-link";

const ContentCs = () => (
    <div className="text-h2Mobile">
        <h2 className="font-bold text-uxfVioletDark sm:text-medium md:text-h5">
            Máte zájem o&nbsp;UX audit?
            <br />
            Pojďme společně nakopnout váš byznys.
        </h2>
        <div className="flex gap-6 pt-6 text-body max-md:flex-col md:gap-16 md:text-medium">
            <TextLink href="mailto:fruhbauer@uxf.cz" variant="orange" underline>
                fruhbauer@uxf.cz
            </TextLink>
            <TextLink href="tel:+420 777 753 897" variant="orange" underline>
                +420 777 753 897
            </TextLink>
        </div>
        <p className="mt-8 text-uxfMuted75 md:mt-12">Nechte nám na&nbsp;sebe kontakt, ozveme se vám.</p>
    </div>
);

const ContentEn = () => (
    <div className="text-h2Mobile">
        <h2 className="font-bold text-uxfVioletDark sm:text-medium xl:text-h5">
            Are you interested in a UX audit?
            <br />
            Let&apos;s kickstart your business together.
        </h2>
        <div className="flex gap-6 pt-6 text-body max-md:flex-col md:gap-16 md:text-medium">
            <p>
                <TextLink href="mailto:fruhbauer@uxf.cz" variant="orange" underline>
                    fruhbauer@uxf.cz
                </TextLink>
            </p>
            <p>
                <TextLink href="tel:+420 777 753 897" variant="orange" underline>
                    +420 777 753 897
                </TextLink>
            </p>
        </div>
        <p className="mt-8 text-uxfMuted75 md:mt-12">
            Leave us your contact information and we&apos;ll get back to you.
        </p>
    </div>
);
export const AuditContactSection = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <div className="contact-section mb-14 flex flex-col border-2 px-5 pt-6 md:container max-md:mx-4 md:px-16 md:pt-12">
            <div className="pb-12">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
            <AuditContactForm />
        </div>
    );
};
